export default __webpack_public_path__ + "static/media/restaurant_basic_ui.91da01f9.PNG";